import { render, staticRenderFns } from "./DoctorAboutProfessionalForm.vue?vue&type=template&id=e777fd58&"
import script from "./DoctorAboutProfessionalForm.vue?vue&type=script&lang=js&"
export * from "./DoctorAboutProfessionalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports